





















import { computed, defineComponent, PropType } from '@vue/composition-api';
import { CardPlan } from '../../../models';
import PlanCard from './PlanCard.vue';
import { MembershipType, SubscriptionType } from '@ligo/shared/auth';

export default defineComponent({
  name: 'PlanList',
  components: { PlanCard },
  props: {
    plans: {
      type: Array as PropType<CardPlan[]>
    },
    selectedPlan: {
      type: String
    },
    activePlan: {
      type: Number
    },
    currentPlan: {
      type: Object as PropType<SubscriptionType | MembershipType>
    }
  },
  setup(props, { emit }) {
    function onSelect(desirePlan: CardPlan) {
      emit('select', desirePlan);
    }
    const planId = computed(() => props.currentPlan?.id);
    const visiblePlans = computed(() => {
      return props.plans;
    });

    return { onSelect, planId, visiblePlans };
  }
});
